import React from "react";
import Preloader from "../helper/Preloader";
import ColorInit from "../helper/ColorInit";
import HeaderOneMain from "../components/UI/HeaderOneMain";
import Breadcrumb from "../components/UI/BreadcrumbMain";
import FooterOneMain from "../components/UI/FooterOneMain";
import BottomFooter from "../components/UI/BottomFooterMain";
import CartSectionMain from "../components/UI/CartSectionMain";
import ShippingOneMain from "../components/UI/ShippingOneMain";
import ScrollToTop from "react-scroll-to-top";

const CartPage = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOneMain category={true} />

      {/* Breadcrumb */}
      <Breadcrumb title={"Cart"} />

      {/* CartSection */}
      <CartSectionMain />

      {/* ShippingOne */}
      <ShippingOneMain />

      {/* FooterTwo */}
      <FooterOneMain />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default CartPage;
